// externals
import { useDispatch, useSelector } from 'react-redux';

// libraries
import { Snackbar } from '@interstate/components/Snackbar';

// actions
import { purchaseHistoryNotificationDismissed } from '@makemydeal/dr-dash-store/actions/purchaseHistoryActionCreators';
import { activatePurchaseHistoryNotification } from '@makemydeal/dr-dash-store/middleware/purchaseHistoryMiddleware';

// selectors
import * as purchaseHistorySelectors from '@makemydeal/dr-dash-store/selectors/purchaseHistorySelectors';

/** Says nothing about the customer: the manager may be screen-sharing when this appears. */
export const PURCHASE_HISTORY_READY_MESSAGE = 'Purchase history is ready.';

/**
 * Tells the manager a result arrived while they were not looking, and offers one action back to it.
 *
 * Driven entirely by the redux flag, so the "is the manager looking?" judgement stays in the
 * middleware rather than being split across both.
 */
export const PurchaseHistoryReadyNotification = () => {
    const dispatch = useDispatch();
    const isRaised = useSelector(purchaseHistorySelectors.getIsPurchaseHistoryNotificationRaised);

    const handleView = () => {
        // Reopens and scrolls. No new request — that would discard the answer being announced.
        dispatch(activatePurchaseHistoryNotification());
    };

    const handleClose = () => {
        dispatch(purchaseHistoryNotificationDismissed());
    };

    // A WRAPPER, not props: `SnackbarProps` accepts no ARIA attributes and passes nothing through.
    // Rendered unconditionally, because a live region must exist before the change it announces.
    return (
        <div role="status" aria-live="polite" data-testid="purchase-history-ready-live-region">
            <Snackbar
                data-testid="purchase-history-ready-notification"
                show={isRaised}
                message={PURCHASE_HISTORY_READY_MESSAGE}
                position="bottom-center"
                type="info"
                // Explicitly off — it defaults to true, and its 5s is not tunable via any prop.
                // `PURCHASE_HISTORY_NOTIFICATION_MS` in the middleware dismisses this instead.
                autoHide={false}
                onClose={handleClose}
                action={{ label: 'View', onClick: handleView }}
            />
        </div>
    );
};

export default PurchaseHistoryReadyNotification;
